import * as z from "zod";

import { roleContactSchema } from "./role-contact";
import { surrealRecordSchema } from "./surreal-record";

export const roleSchema = surrealRecordSchema.extend({
  name: z.string().optional(),
  description: z.string().optional(),
  externalDescription: z.string().optional(),
  contact: roleContactSchema.optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Role = z.infer<typeof roleSchema>;
